//
//
//
//
//
//

import desc from '@/images/vocation.png'
// import desc from '@/images/production.png'
export default {
    name: 'announcement',
    data () {
        return {
            img: desc
        }
    },
    mounted () {
        document.title = '2022年新春放假通知'
        // document.title = '美缝新品重磅上市'
    }
}



// WEBPACK FOOTER //
// ./src/pages/announcement.vue